import appConfig from "../config/index.json";
export const APP_NOT_FOUND_SEARCH_TITLE = "No application found"
export const APP_NOT_FOUND_SEARCH_DESCRIPTION = "Sorry! We're not able to find any application matching your search keyword."
export const APP_NOT_FOUND_TITLE = "No application available"
export const APP_NOT_FOUND_DESCRIPTION = "Sorry! We're not able to find any application for you. You might not have permission."
export const PWD_RSA_PUB = appConfig.pwdRasPub